import module from 'viaticos/module.js'
import template from './template.html'

export class ViaticosSharedItemCerrarComponent {
  viaticoId
  cerrando
  cerrado = null
  procesando = false
  status
  onClose

  constructor ($q, $state, ViaticosCerrarService) {
    this.$q = $q
    this.$state = $state
    this.ViaticosCerrarService = ViaticosCerrarService
  }

  aceptar () {
    this.procesando = true
    let data = {
      status_cerrado: this.status,
    }
    this.ViaticosCerrarService.put(data, this.viaticoId)
      .then(({data}) => {
        this.cerrando = false
        this.procesando = false
        this.cerrado = data.status_cerrado
      })
  }

  cerrar () {
    this.onClose({$event: {detail: this.cerrado}})
  }
}

module.component('viaticosSharedItemCerrar', {
  controller: ViaticosSharedItemCerrarComponent,
  template,
  bindings: {
    cerrando: '<',
    status: '<',
    viaticoId: '<',
    onClose: '&',
  },
})



// WEBPACK FOOTER //
// ./src/viaticos/components/shared/item/cerrar/component.js